import React from "react";

import history from "appHistory";

import WaitForSync from "components/LoadingSpinner/WaitForSync";

import { ApiModel } from "constants/loading";
import { ModalTypes } from "constants/navigation";

import SaleLot from "containers/SaleLot";

import { closeAllHashModals, openEditSaleLotModal } from "lib/navigation";
import { useIsMobile } from "hooks/useScreenSize";
import { useHasAlternativeMobileWorkflowPermission } from "hooks/useHasPermission";
import { MobileTransactionalEditSaleLotModal } from "components/MobileTransactionalModal";
import { useSelector } from "react-redux";
import { getCurrentSaleType } from "selectors";
import { TransactionalSaleTypes } from "constants/sale";

function EditSaleLotModalAdapter(props) {
  const { hash } = props;
  const hashParams = hash[ModalTypes.EditSaleLot] || null;
  const [saleLotId, section, action, consignmentId, copyFrom, tab] =
    JSON.parse(hashParams);

  const { returnTo } = hash;
  const decodedReturnTo = returnTo ? atob(returnTo) : "";

  const isMobile = useIsMobile();
  const saleType = useSelector(getCurrentSaleType);

  const isTransactionalSale = TransactionalSaleTypes.includes(saleType);

  const hasAlternativeMobileWorkflowPermission =
    useHasAlternativeMobileWorkflowPermission();

  function onClose() {
    if (decodedReturnTo) {
      history.push(decodedReturnTo);
    } else {
      closeAllHashModals();
    }
  }

  // Changing tabs is mobile only - it adds a new history record to the url
  // This to match changeSection logic - so that a tab can be used in the hash
  // enabling a user to navigate directly to/back to a specific tab
  function changeTab(newTab) {
    openEditSaleLotModal(
      saleLotId,
      section,
      action,
      consignmentId,
      copyFrom,
      decodedReturnTo,
      newTab,
    );
  }

  if (
    isMobile &&
    isTransactionalSale &&
    hasAlternativeMobileWorkflowPermission
  ) {
    return (
      <WaitForSync requiredData={[ApiModel.SALE_LOTS, ApiModel.SPECIES]}>
        <MobileTransactionalEditSaleLotModal
          saleLotId={saleLotId}
          consignmentId={consignmentId}
          onClose={onClose}
          tab={tab}
          changeTab={changeTab}
        />
      </WaitForSync>
    );
  }

  function changeSection(currentSection, newSection) {
    openEditSaleLotModal(
      saleLotId,
      currentSection === newSection ? null : newSection,
      action,
      consignmentId,
      copyFrom,
      decodedReturnTo,
    );
  }

  return (
    <WaitForSync requiredData={[ApiModel.SALE_LOTS, ApiModel.SPECIES]}>
      <SaleLot
        saleLotId={saleLotId}
        section={section}
        action={action}
        consignmentId={consignmentId}
        copyFrom={copyFrom}
        changeSection={changeSection}
        returnTo={decodedReturnTo}
        {...props}
      />
    </WaitForSync>
  );
}

export default EditSaleLotModalAdapter;
